import React from "react";
import { Link } from "react-router-dom";
import { DISCIPLINES, PORTES_OUVERTES_URL, PORTES_OUVERTES_WIDGET_URL } from "@/lib/data";
import { ArrowRight } from "lucide-react";
import { http } from "@/lib/api";
import HelloAssoWidget from "@/components/HelloAssoWidget";

export default function Cours() {
  const [courses, setCourses] = React.useState([]);
  const [disciplines, setDisciplines] = React.useState(DISCIPLINES);
  React.useEffect(() => {
    http.get("/courses").then((r) => setCourses(r.data)).catch(() => setCourses([]));
    http.get("/disciplines").then((r) => { if (Array.isArray(r.data) && r.data.length) setDisciplines(r.data); }).catch(() => {});
  }, []);

  const courseByName = React.useMemo(() => {
    const m = {};
    for (const c of courses) {
      const key = c.name.toLowerCase();
      if (!m[key]) m[key] = [];
      m[key].push(c);
    }
    return m;
  }, [courses]);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 sm:py-24">
      <p className="he-overline text-neutral-500">Afrolat’Studio</p>
      <h1 className="font-heading text-5xl sm:text-6xl font-black tracking-tighter mt-3">Nos danses</h1>
      <p className="mt-4 max-w-2xl text-neutral-600 font-body">
        Afro, latino, urbain, danses de couple, orientale, heels, fitness : découvrez chaque discipline et trouvez celle qui vous ressemble.
      </p>

      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {disciplines.map((d) => {
          const sessions = courseByName[d.name.toLowerCase()] || [];
          return (
            <article key={d.slug} className="group border border-black/10 rounded-2xl p-6 hover:border-[var(--he-red)] transition-colors flex flex-col">
              <span className="he-overline text-neutral-500">{d.tag}</span>
              <h3 className="font-heading text-2xl font-bold tracking-tight mt-2">{d.name}</h3>
              <p className="mt-2 text-sm text-neutral-600 font-body">{d.desc}</p>

              {sessions.length > 0 ? (
                <ul className="mt-4 text-xs text-neutral-500 font-body space-y-1">
                  {sessions.slice(0, 3).map((s) => (
                    <li key={s.id}>· {s.day} {s.start}-{s.end} · {s.city}{s.level && s.level !== "tous niveaux" ? ` · ${s.level}` : ""}</li>
                  ))}
                </ul>
              ) : (
                <p className="mt-4 text-xs text-neutral-400">Créneaux à venir.</p>
              )}

              <div className="mt-6 pt-4 border-t border-black/5 flex flex-wrap gap-2">
                <a href={PORTES_OUVERTES_URL} target="_blank" rel="noreferrer" className="btn-red rounded-full px-4 py-2 text-xs">Faire un essai</a>
                <Link to="/planning" className="text-xs rounded-full px-4 py-2 border border-black/20 hover:bg-black hover:text-white transition-colors inline-flex items-center gap-1">Voir horaires <ArrowRight className="w-3 h-3" /></Link>
              </div>
            </article>
          );
        })}
      </div>

      <section data-testid="cours-essai-widget" className="mt-20 max-w-3xl mx-auto text-center">
        <p className="he-overline text-neutral-500">Cours d’essai</p>
        <h2 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight mt-2">Réservez votre cours d’essai</h2>
        <p className="mt-3 text-sm text-neutral-600 font-body">Choisissez votre discipline et votre créneau, puis réservez en ligne — inscription en 2 minutes via HelloAsso.</p>
        <div className="mt-8 border border-black/10 rounded-2xl overflow-hidden text-left">
          <HelloAssoWidget url={PORTES_OUVERTES_WIDGET_URL} />
        </div>
      </section>
    </div>
  );
}
